import { DELETE_AUDIO_CLIP, LOAD_AUDIO_CLIPS } from '../constants/ActionTypes'

/**
 * @typedef {import('../index').PlottrFileAudioClips} PlottrFileAudioClips
 * @typedef {import('../types/plottr').AudioClipRecord} AudioClipRecord
 */

/**
 * @typedef {ReturnType<typeof load> | ReturnType<typeof deleteAudioClip>} AudioClipsActions
 */

/**
 * @param {boolean} patching
 * @param {PlottrFileAudioClips} audioClips
 * @return {{ type: 'LOAD_AUDIO_CLIPS', patching: boolean, audioClips: PlottrFileAudioClips }}
 */
export function load(patching, audioClips) {
  return { type: LOAD_AUDIO_CLIPS, patching, audioClips }
}

/**
 * @param {number} id
 * @return {{ type: 'DELETE_AUDIO_CLIP', id: number }}
 */
export function deleteAudioClip(id) {
  return {
    type: DELETE_AUDIO_CLIP,
    id,
  }
}
